var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{staticClass:"md-12"},[(_vm.isfaq)?_c('servicerequestdetails'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }